
const NoDataBacklink = () => {
  return (
    <div className="d-flex flex-column gap-6 justify-content-center align-items-center mt-7">
      {/* <FontAwesomeIcon color={getColor('secondary')} size="10x" icon="link" /> */}
      <span style={{ width: '500px', maxWidth: '100%' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 150 150"
          enableBackground="new 0 0 150 150"
        >
          <g
            fill="none"
            stroke="var(--falcon-primary)"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          >
            <g strokeWidth="2">
              <path d="m51.9 25.8l14-4.3 64.7 58.5-72 22.8 9.8-49.8-8.3-8-14.7 74.5-10.8-7.5z" />
              <path d="m60.5 92l48.3-16.5v-.2l-57.5-49.5" />
              <path d="m98.5 79.3l-38.2-34" />
              <path d="m45.4 119.5l85-27.5.2-12" />
            </g>
            <path d="m34.9 107.8l11.3 7.5" />
            <path d="m35.9 104.8l11.3 7.5" />
            <path d="m35.9 100.8l11.3 7.5" />
            <path d="m36.9 97.8l11.3 7.5" />
            <path d="m96 77l9.9-3.5" />
            <path d="m93.9 74.8l9.9-3.6" />
            <path d="m91.3 72.5l9.9-3.5" />
            <path d="m59.3 49.2l8.1 7.7" />
            <path d="m58.4 52.5l8.2 7.8" />
            <path d="m57.8 56.5l8.2 7.7" />
            <path d="m64.2 90.9l-2 10.5" />
            <path d="m67.2 89.9l-2 10.5" />
            <path d="m70.2 88.9l-2 10.5" />
            <path d="m73.2 87.9l-2 10.5" />
          </g>
          <path
            opacity=".08"
            fill="var(--falcon-primary)"
            d="M60.2 45.2 45.4 119.3 130 92 130 80.2 58.4 102.7 68.2 53z"
          />
          <g
            fill="none"
            stroke="var(--falcon-primary)"
            strokeLinecap="round"
            strokeWidth="1.526"
            strokeMiterlimit="10"
          >
            <path d="m26.2 84.3l-3.7 3.5" />
            <path d="m26.2 87.9l-3.7-3.8" />
            <path d="m101.7 106.5l.5 5.1" />
            <path d="m104.5 108.8l-5.2.5" />
            <path d="m98.2 37.3l-3.7 3.5" />
            <path d="m98.2 40.9l-3.7-3.8" />
          </g>
          <ellipse
            transform="matrix(.9998-.01789.01789.9998-2.313 1.428)"
            cx="78.6"
            cy="130"
            rx="25.3"
            ry="7.4"
            opacity=".08"
            fill="var(--falcon-primary)"
          />
        </svg>
      </span>
      <div className="fs-1 fw-medium">
        برای مشاهده بک‌لینک های یک دامنه ، باید آدرس دامنه آن راوارد نمایید.
      </div>
    </div>
  );
};

export default NoDataBacklink;
